<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/rHfMJX/tc-custom/9781514002476.jpg?1696025454926" alt="This image is the cover for the book Road to Flourishing"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Road to Flourishing
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong>What makes for a flourishing workplace?</strong> </p> <p>Many organizations find themselves spinning their wheels in work cultures filled with toxicity, dysfunction, conflict, and fear. Unengaged employees drag down productivity, and ineffective management undermines morale. How can we create workplaces where people don't just struggle to get through the day but instead thrive and love what they do and where they work?</p> <p>Al Lopus, cofounder and CEO of Best Christian Workplaces Institute, has studied hundreds of organizations to discover eight key drivers in companies with healthy culture and engaged employees. He gathers best practices from across a range of companies and ministries to demonstrate how people at all levels can work together to accomplish work that matters. Principles and real-life examples provide concrete ways that organizations can flourish by building fantastic teams, cultivating life-giving work, attracting and retaining outstanding talent, and much more.</p> <p>With compelling case studies, behind-the-curtain revelations, and enlightening personal anecdotes, <em>Road to Flourishing</em> will motivate leaders, managers, and their teams to reimagine, reassess, and renew their commitment to building healthy work cultures where everyone can flourish.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Al Lopus, Cory Hartman, Peter Greer
      </h2>
      
      <p class="authorDescription body article"><p>Al Lopus is the president and CEO of the Best Christian Workplaces Institute (BCWI), which provides research-based measurement tools and strategic advisory services with a single vision: to help Christian organizations set the standard as the best, most effective workplaces in the world. At BCWI, Al has pioneered the broadest-ever employee engagement survey of Christian workers. To date, the survey has involved more than 1,000 Christian organizations, with employees completing over 300,000 survey questionnaires. Prior to cofounding BCWI, Al served for over twenty years in leadership roles with the global human resource consulting firm Watson Wyatt (now Willis Towers Watson), where he built a reputation for his vision and implementation of human capital programs for clients such as Boeing, Alaska Airlines, Federal Deposit Insurance Corporation (FDIC), and USAA. A former board member of Christian Leadership Alliance, Al currently serves on the association's advisory council. He also served on the Board of Trustees for Virginia Mason Medical Center, a 5,000-employee, award-winning healthcare organization. He and his wife, Kathy, are the parents of two adult daughters.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0343ee30